import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../../lib/apiCaller";

export const track = createAsyncThunk(
  "track/track",
  async (payload, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "APP_DOWNLOAD",
        method: "POST",
        body: payload,
        useContent: true,
      });
      return res.data;
    } catch (error) {
      // Log error silently for production, don't affect customer experience
      console.error("Tracking API failed:", error?.message || error);
      // Return null to indicate failure without throwing
      return null;
    }
  },
);

const initialState = {
  city: "",
  latitude: null,
  longitude: null,
  addressLine1: "",
  addressLine2: "",
  state: "",
  country: "",
  postalCode: "",
  loginTime: null,
};

const trackSlice = createSlice({
  name: "track",
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.city = action.payload.city;
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;

      state.addressLine1 = action.payload.addressLine1;
      state.addressLine2 = action.payload.addressLine2;
      state.state = action.payload.state;
      state.country = action.payload.country;
      state.postalCode = action.payload.postalCode;
    },
    setLoginTime: (state, action) => {
      state.loginTime = action.payload;
    },
  },
});

export const { setLocation, setLoginTime } = trackSlice.actions;
export default trackSlice.reducer;
